import { applyMiddleware, createStore } from 'redux'
import { multiClientMiddleware } from 'redux-axios-middleware'

import logger from 'redux-logger'

import reducer from '@reducers/reducer'
import clients from '@services/api'

const middleware = [multiClientMiddleware(clients)]

if (process.env.NODE_ENV === 'development') {
  middleware.push(logger)
}

const store = createStore(
  reducer,
  applyMiddleware(...middleware)
)

export default store
